// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
// import "@hotwired/turbo-rails"

// @hotwired/stimulus-loading is an importmap‑only helper.

// With esbuild, remove that import and manually register controllers, or use a bundler‑friendly loader.

// Keep @hotwired/stimulus installed via Yarn.

// Entry point for the build script in your package.json
// Rails 8 uses import maps or bundlers (ESBuild/Vite/Bun).
// All files should now live directly under app/javascript/, not packs/.

// TO DO: WHEN MIGRATIon is complete remove
import Rails from "@rails/ujs"
Rails.start()



// Import your custom modules (moved from packs/ to app/javascript/)
import "./aglobals"
import "./bank_accounts"
import "./budgets"
import "./financial_assets"
import "./date-functions"
import "./payment_vouchers"
import "./petty_cash"
import "./revenues"
import "./recaptcha"
import "./scripts-jquery"
import "./organizationSetup"
import "./reconciliation"
import "./productStock"
import "./services"
import "./paymentOptions"
import "./customerPayments"
import "./floatPurchase"
import "./floatSale"
import "./agentFloatTransfer"
import "./floatReturns"
import "./stockTransfers"
import "./liveBalances"
import "./purchasePayments"
import "./loans"
import "./loanRepayments"

// Stimulus controllers (Rails 8 default)
import "./controllers"

// Images (optional, if you still need them)
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

